




















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import CountriesSelector from '@shared/components/forms/inputs/countries-selector/countries-selector.vue';
import PostalCodeInput from '@shared/components/forms/inputs/postal-code-input/postal-code-input.vue';

@Component({
  name: 'bpc-pos-ask-origin-modal',
  components: {
    'bpc-countries-selector': CountriesSelector,
    BpcInput,
    'bpc-postal-code-input': PostalCodeInput,
  },
})
export default class PosAskOriginModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly ticketId!: number;
  // DATA
  addingOrigin = false;

  origin = '';
  postalCode = '';
  country = this.$store.getters['centerSettings/countryCode'];
  city = '';

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.restartValues();
    this.$emit('close');
  }

  restartValues() {
    this.origin = '';
    this.postalCode = '';
    this.country = this.$store.getters['centerSettings/countryCode'];
    this.city = '';
  }

  onEnterKey() {
    this.$nextTick(() => {
      this.onConfirm();
    });
  }

  async onConfirm() {
    this.addingOrigin = true;
    this.origin = this.city ? `${this.postalCode} - ${this.city}` : this.postalCode;

    try {
      const ticket = await this.$posService.addOrigin(
        this.posSessionId,
        this.ticketId,
        this.origin,
      );
      this.$emit('ticket-detail-updated', ticket);
      this.closeModal();
    } catch (error) {
      this.handleError(error);
    }

    this.addingOrigin = false;
    this.restartValues();
  }

  handleError(error: any) {
    console.log(error);
  }

  onSelectedCity(city: string) {
    this.city = city;
  }

  get countryOptions() {
    return this.$bpcHelper.countryOptions();
  }

  // WATCHERS
}
